var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Invoice',{ref:"Invoice",attrs:{"order":_vm.selectedOrder}})
}
var staticRenderFns = []

export { render, staticRenderFns }